export const AUTH_NAMESPACE = 'app_auth'
export const AUTH_LOAD_TIMEPUNCH_NAMESPACE = 'app_auth_load_timepunches'
export const AUTH_TIMEPUNCH_NAMESPACE = 'app_auth_timepunch'
export const RESORT_COMPANY_WIZARD_SUBMITTING = 'resort_company_wizard_submit'
